<template>
  <div>
    <template v-if="element.autoGenerate">
      <component
        :is="element.fieldType"
        v-model="model"
        :element="element"
      />
    </template>
  </div>
</template>

<script>
  import elementGeneratorMixin from "./items/elementGeneratorMixin";
  import checkboxItem from "./items/checkboxItem";
  import colorPickerItem from "./items/colorPickerItem";
  import datePickerItem from "./items/datePickerItem";
  import inputItem from "./items/inputItem";
  import selectorItem from "./items/selectorItem";
  import labelItem from "./items/labelItem";
  import modelSelectorItem from "./items/modelSelectorItem";
  import moneyItem from "./items/moneyItem";
  import numberItem from "./items/numberItem";
  import parameterSelectorItem from "./items/parameterSelectorItem";
  import percentageItem from "./items/percentageItem";
  import radioItem from "./items/radioItem";
  import uploadItem from "./items/uploadItem";
  import multiLineItem from "./items/multiLineItem";
  import enumSelectorItem from './items/enumSelectorItem'
  import compositeListItem from './items/compositeListItem'
  import compositeModelItem from "./items/compositeModelItem";

  export default {
    name: "QElementGenerator",

    components:{
      'CompositeList': compositeListItem,
      'Enum': enumSelectorItem,
      // 'Image': imageItem,
      // 'Password': passwordItem,
      // 'MonthPicker': monthPickerItem,
      // 'Icon': iconItem,
      'CompositeModel': compositeModelItem,
      'ModelSelector': modelSelectorItem,
      'Parameter': parameterSelectorItem,
      'DatePicker': datePickerItem,
      'CheckBox': checkboxItem,
      'ColorPicker': colorPickerItem,
      'TextItem': inputItem,
      'MultiLineText': multiLineItem,
      'Selector': selectorItem,
      'LabelItem': labelItem,
      'Currency': moneyItem,
      'Number': numberItem,
      'Percentage': percentageItem,
      'Radio': radioItem,
      'File': uploadItem,
    },

    mixins: [elementGeneratorMixin],
  }
</script>